import log from 'loglevel';

// Set the desired log level (trace, debug, info, warn, error, silent)
log.setLevel('debug');

// Override default console methods
console.log = log.info.bind(log);
console.error = log.error.bind(log);

export default log;
